export default __webpack_public_path__ + "static/media/certificado-digital.3ee0a0d7.png";